<template>
	<div :class="['overlay', overlayClass]">
		<div class="modal">
			<component :is="componentName" v-bind="data" v-if="isActive" />
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";
import AboutModal from "@/components/game/info-panel/AboutModal";
import PolicyModal from "@/components/game/info-panel/PolicyModal";
import SpinResultModal from "@/components/game/spin/SpinResultModal";
import ExplanationModal from "@/components/game/shop/ExplanationModal";

export default {
	name: 'ModalOverlay',
	components: {
		AboutModal,
		PolicyModal,
		SpinResultModal,
		ExplanationModal,
	},
	computed: {
		...mapState("global/modal", {
			overlayClass: (state) => state.class,
			componentName: (state) => state.component,
			isActive: (state) => state.active,
			data: (state) => state.data,
		}),
	},
};
</script>

<style lang="scss" scoped>
	.overlay {
		align-items: center;
		background: rgba(0, 0, 0, .5);
		display: flex;
		height: 100%;
		justify-content: center;
		position: fixed;
		top: 0;
		width: 100%;
		z-index: $z-top;

		&.full-width { width: 100vw; }
	}

	.modal {
		height: 100%;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		position: absolute;
		right: 0;

		.about &,
		.policy & {
			align-items: flex-start;
			overflow: scroll;
		}

		.about & { background: $alt-color-dark; }
		.policy & { @include gradient-background }
	}
</style>
